import React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router-dom";

import "Common.css";
import "./VisitUpdateReview.css";

import BaseElem from "BaseElem";
import {
  parseDate,
  dateToAMPM,
  formatDate,
  formatTime,
  convertToDestTZ,
} from "Util/DateUtils";
import {
  CUSTOMER_REQUEST_DATE,
  INITIATED_BY,
  REASON_FOR_CHANGE,
  REASON_FOR_CHANGE_DETAILS,
} from "../Dialogs/DialogCompUpdateVisit";
import {
  UNDEF,
  API_LONG_VISITS_BY_ID,
  MSG_SHOW_CALENDAR_VIEW,
  MSG_FETCH_VISITS,
  MSG_REFRESH_CR_DETAILS,
  API_VAL_CONFIRM_BOOKING,
  c7C7C7C,
  API_VAL_GET_BREAKDOWN,
  MSG_REFRESH_CR_INFO,
} from "Constants";
import Api, { showSnackbar } from "../../Api";
import {
  capitalize,
  cblur,
  postMessage,
  getCOName,
  getCurrencyCode,
  stripCurrency,
  isBlank,
  getCurrencySymbol,
} from "Util/Utilities";
import { getLocationText } from "../LocationInput";
import {
  NURSE_REQUIREMENTS,
  MOBILITY_TYPES,
  VISIT_BREAK_OPTIONS,
  visit_location_address,
  requested_services,
  meal_requirements,
  nursing_procedure,
  is_nurse_required,
  is_nurse_requested,
  reason_for_nurse,
  home_rehabilitation,
  home_medical,
  ambulant,
  mobility_instruction,
  special_requests_instructions,
  has_manual_transfer,
  require_vital_sign,
  manual_transfer_help,
  manual_transfer_help_details,
  transfer_points,
  bed,
  transfer_type,
  internal_ops_cr_note,
  payment_breakdown,
  visit_schedule,
  required_cp,
  breaks,
  internal_ops_fulfillment_note,
  MEAL_ARRANGEMENT,
  MEDICAL_ESCORT,
  companionship_description,
  home_medical_details,
  COMPANIONSHIP,
  therapy_details,
  expected_outcome,
  doctor_memo,
  blob_urls,
  doctor_memo_available,
  have_hoist,
  co_accept_2_cps,
  APP_COUNTRY,
  isAU,
} from "DataConstants";
import PricingEngineVisitBreakdownItem from "Screens/Pricing/VisitBreakdown/PricingEngineVisitBreakdownItem";

import { getDuration } from "../DateTimeDisplay";
import { IconButton, Button } from "@material-ui/core";
import { Close, ExpandLess } from '@mui/icons-material';
import Checkbox from "@material-ui/core/Checkbox";
import { PortalDialog } from "../CommonComponents";
import { TextDropdown } from "../TextDropdown";
import { InputField } from "../InputField";
import { resetPricing } from "Actions/PricingActions";
import { getReasons } from "Actions/VisitActions";
import { WalletDropdown } from "../WalletDropdown";
import {
  PayThemselvesMode,
  PayThemselvesSuccessPopup,
  PEConfirmPopup,
  CoUpdateErrorPopup,
} from "Screens/Pricing/PEConfirmPopup";
import { Elements } from "@stripe/react-stripe-js";
import { stripePromise } from "Screens/CareOwner/SubComponents/NewCareRecipient/IPCAScheduling";
import {
  Package,
  PayOnCall,
  BreakdownDetail,
  VisitBreakdownResponse,
  Visit,
  Procedure,
} from "../../@types/PricingModels";
import { Div, Img, Txt } from "../GenericView";
import { getMedicalEscortDetails } from "../MedicalEscort/MedicalEscort";
import { PatientDeclarationDisplay } from "../PatientDeclaration/PatientDeclaration";
import { AdditionalRequirementsInfo } from "../Dialogs/AdditionalRequirements";
import { getDraftVisits } from "../ListView/VisitDraftsListView";
import moment from "moment";

type VisitUpdateReviewProps = {
  recipientStore?: any;
  visitDraftStore?: any;
  pricingStore?: any;
  reasons?: any;
  match: any;
  reviewUpdateData?: any;
  coId?: string;
};

type VisitUpdateReviewConnectProps = {
  resetPricing: () => void;
  getReasons: () => void;
  visitStore?: any;
};

type ChangeType = {
  title: string;
  icon: string;
  before: any;
  after: any;
  className?: string;
};

type VisitUpdateReviewState = {
  // Visits from Update Review api
  // have info to retain cps, change fees etc.
  reviewResponse?: any;

  // Original Full visits
  originalVisits?: any;

  afterVisits?: any[];

  // New visits with new pricing items are in
  // props.visitDraftStore.updateVisitsData

  // detailed changes (before & after) for the popup
  changes: ChangeType[];
  changeDetailOpen?: boolean;

  // expanded groups hashmap
  expandedIds: any;

  //  reqBody: any;

  breakdownRequest?: any;
  breakdownResponse?: any;
  selectedPackage?: Package;

  confirmPopupOpen?: boolean;
  payThemselvesSuccess?: boolean; // pay themselves success popup
  coUpdateError?: any; // CO already updated error message
};

const ME_INSTRUCTIONS = "Medical Escort Instructions";
const ADL_SERVICES = "ADL Services";
const incidentCenter = window.location.search.includes(
  "source=incident-centre"
);

type VisitUpdateReviewActualProps = VisitUpdateReviewProps &
  VisitUpdateReviewConnectProps &
  RouteComponentProps<any>;

const RETAIN_CP = "retain_cp";
const RETAIN_REASON = "retain_reason";
const RETAIN_REASON_DETAILS = "retain_reason_details";
const WAIVE_CHANGE_FEE = "waive_change_fee";
const WAIVE_REASON = "waive_reason";
const WAIVE_REASON_DETAILS = "waive_reason_details";
const CP_COMPENSATION = "cp_compensation";
const COMPENSATE_CP = "compensate_cp";

class VisitUpdateReview extends BaseElem<
  VisitUpdateReviewActualProps,
  VisitUpdateReviewState
> {
  // earliest start time for visits
  firstVisitStartTime = new Date();

  constructor(props: VisitUpdateReviewActualProps) {
    super(props);
    const self = this;

    self.state = {
      changes: [],

      // expanded visit ids
      expandedIds: {},

      // Update visit api Request body
      //reqBody: {},
    };

    if (!props.visitStore || !props.visitStore.reasons) props.getReasons();
  }

  componentWillUnmount() {
    this.props.resetPricing();
  }

  componentDidMount() {
    const self = this,
      props = self.props;
    const updateData = props.reviewUpdateData;
    if (!updateData) return;

    // update visit draft id (temporarily disabled)
    const draftId = updateData._id;
    const isFromDraft = !!draftId && updateData.conditions_changed === false;

    const carepros = "carepros";
    //const original_visit = "original_visit";
    //const updated_visit = "updated_visit";

    const reqBody = Object.assign({}, updateData);
    const originalVisit = reqBody.originalVisit;
    const selectedPackage = reqBody.selectedPackage;
    const breakdownResponse = reqBody.breakdownResponse;
    const breakdownRequest = reqBody.breakdownRequest;

    const vd = (v: any) => parseDate(v[visit_schedule].date_from).getTime();
    const visits = (breakdownRequest.visits_info.visits || []).sort(
      (a: any, b: any) => vd(a) - vd(b)
    );

    self.firstVisitStartTime = parseDate(visits[0][visit_schedule].date_from);

    if (!isFromDraft) {
      const rvisits = breakdownResponse.visits_update_info;
      // change id to _id for visit udpate api
      for (let k = 0; k < rvisits.length; k++) {
        rvisits[k][carepros] = rvisits[k][carepros].map((cp: any) => {
          if (cp.id) {
            cp._id = cp.id;
            delete cp.id;
          }
          return cp;
        });
      }
      // Assign carepros to request body visits
      const visitsMap = self._toMap(rvisits, carepros);

      self.setState({
        reviewResponse: visitsMap,
        selectedPackage: selectedPackage,
        breakdownResponse: breakdownResponse,
        breakdownRequest: breakdownRequest,

        afterVisits: visits,
      });

      const getParams =
        "?visit_ids[]=" +
        visits.map((v: any) => v._id || v.visit_id).join("&visit_ids[]=");
      Api.GET(
        API_LONG_VISITS_BY_ID + getParams,
        (resp) => {
          const orgVisits = resp && resp.data && resp.data.visits;
          if (!orgVisits) return;
          self.setState({ originalVisits: self._toMap(orgVisits) });
        },
        true,
        true,
        true
      );

      self._computeChanges(originalVisit, visits[0]);
    }

    /*/ resume from saved drafts
    else {
      self.setState({
        reqBody: reqBody,
        reviewResponse: self._toMap(visits, carepros),
        originalVisits: self._toMap(visits, original_visit),
        afterVisits: visits.map((v: any) => {
          const visit = v[updated_visit];
          visit._id = v.visit_id;
          return visit;
        }),
      });
      const firstVisit = visits[0];
      self._computeChanges(
        firstVisit[original_visit],
        firstVisit[updated_visit]
      );
    }*/

    self._expandAll(visits);
  }

  getRegion = () => {
    const { recipientStore } = this.props;
    const timezone = recipientStore?.careRecipient?.cr?.timezone;
    let region = timezone?.timezones?.[APP_COUNTRY];
    if (timezone?.is_single_tz === false) {
      const city = recipientStore?.careRecipient?.co?.address_list?.[0]?.city;
      region = timezone.timezones[city];
    }
    return region;
  };

  _toMap(arrOfVisits: any[], prop?: string) {
    return arrOfVisits.reduce((map: any, visit: any) => {
      map[visit._id || visit.visit_id] = prop ? visit[prop] : visit;
      return map;
    }, {});
  }

  _dateText(data: any) {
    const date =
      convertToDestTZ(
        parseDate(data[CUSTOMER_REQUEST_DATE]),
        this.getRegion()
      ) ?? new Date();
    return formatDate(date) + ", " + formatTime(date);
  }
  _initiator(data: any) {
    return data[INITIATED_BY] === "homage"
      ? "Homage"
      : "Care Owner / Organisation";
  }
  _summarySecHidden() {
    const state = this.state;
    return !state.originalVisits || !state.reviewResponse;
  }

  _isConfirmEnabled() {
    const self = this;
    const state = self.state;
    const reviewResponse = state.reviewResponse;

    if (!reviewResponse) return false;

    const retainReasons = self._getReasons(true);
    const waiveReasons = self._getReasons(false);

    const cpInfos: any = Object.values(reviewResponse);

    // retain cp & waive fee validations
    for (let j = cpInfos.length; j--;) {
      const carepros = cpInfos[j] || [];
      for (let k = carepros.length; k--;) {
        const cp = carepros[k];
        if (cp[RETAIN_CP]) {
          if (
            !cp[RETAIN_REASON] ||
            (self._isDetailsRequired(retainReasons, cp[RETAIN_REASON]) &&
              !(cp[RETAIN_REASON_DETAILS] || "").trim())
          ) {
            return false;
          }
        }

        if (cp[WAIVE_CHANGE_FEE]) {
          if (
            !cp[WAIVE_REASON] ||
            (self._isDetailsRequired(waiveReasons, cp[WAIVE_REASON]) &&
              !(cp[WAIVE_REASON_DETAILS] || "").trim())
          ) {
            return false;
          }
        }
      }
    }

    return true;
  }

  /*_discardChanges = () => {
    const self = this,
      state = self.state,
      req = state.reqBody;
    Api.POST(API_UPDATE_DRAFTS_DELETE, { draft_ids: [req._id] }, (resp) => {
      if (resp) {
        postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF, 200);
        postMessage(MSG_FETCH_VISITS, { spinnerDuration: 1000 }, 500);
      }
    });
  };

  //TODO: update
  _saveChanges = () => {
    const self = this,
      state = self.state,
      reqBody = Object.assign({}, state.reqBody);
    const visits = reqBody.visits,
      count = visits.length;
    if (!count) {
      return;
    }

    reqBody.visits = visits.map((v: any) => {
      return {
        visit_id: v.visit_id,
        carepros: state.reviewResponse[v.visit_id],
        updated_visit: v.updated_visit,
        original_visit: (state.originalVisits || {})[v.visit_id],
      };
    });

    const firstVisitDate = parseDate(
      visits[0].updated_visit[visit_schedule].date_from
    );

    Api.POST(API_UPDATE_DRAFTS_SAVE, reqBody, (resp) => {
      if (resp) {
        postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF, 200);
        const snackbarText = `Changes saved successfully`;
        postMessage(
          MSG_FETCH_VISITS,
          {
            message: snackbarText,
            date: firstVisitDate,
            spinnerDuration: 1000,
          },
          500
        );
      }
    });
  };*/

  // Confirm update visits
  _confirmUpdate = () => {
    const self = this;
    const state = self.state;

    //first refresh the breakdown
    const request = state.breakdownRequest;
    const reviewResponse = state.reviewResponse;
    const visitDrafts = getDraftVisits(this.props);
    visitDrafts.forEach((draft: any) => {
      const isHPC = this.props.location.pathname.includes("/hpc");
      if (
        isHPC &&
        (!draft.status ||
          draft.status.visit === "Open" ||
          draft.status.visit === "Requested")
      ) {
        const dateFrom = draft[visit_schedule]["date_from"];
        const currentTime = moment();
        const startTime = moment(dateFrom);
        const cutOffTime =
          this.props.recipientStore?.careRecipient?.co?.visit_too_close_time ??
          1;
        if (cutOffTime) {
          const hoursDiff = startTime.diff(currentTime, "hours");
          const addCuttOffTimeInCurrentTime = currentTime.add(
            cutOffTime * 60 + 15, // cuttOff hours(in minutes) + 15min
            "minutes"
          );
          if (!incidentCenter && hoursDiff < cutOffTime) {
            showSnackbar(
              `Please select the visit start time after ${addCuttOffTimeInCurrentTime.format(
                "hh:mm"
              )} slot.`,
              "error",
              3000
            );
            return;
          }
        }
      }
    });
    const visitUpdateInfoVisits = request.visits_info.visits.map((v: any) => {
      return {
        visit_id: v._id,
        carepros: reviewResponse[v._id] || [],
      };
    });
    const updateInfo = request.visits_update_info;
    updateInfo.visits = visitUpdateInfoVisits;
    request.visits_info.visits_update_info = updateInfo;
    // Get new breakdown with change fees
    Api.POST(
      API_VAL_GET_BREAKDOWN,
      request,
      (resp) => {
        //TODO: remove testing data later
        const data =
          resp?.data /*|| test_breakdownResponse*/ as VisitBreakdownResponse;
        // continue with visit updates
        data &&
          self.setState({ breakdownResponse: data }, () => {
            if (data.can_immediate_confirm) {
              self._callConfirmApi(state.breakdownRequest);
            } else {
              self.setState({ confirmPopupOpen: true });
            }
          });
      },
      true
    );

    //TODO: fix this
    /*const self = this,
      reqBody = self.state.reqBody;

    if (!self._isConfirmEnabled()) return;
    const visits = reqBody.visits,
      count = visits.length;
    const firstVisitDate = parseDate(
      visits[0].updated_visit[visit_schedule].date_from
    );

    Api.POST(API_UPDATE_VISITS, reqBody, (resp) => {
      if (resp) {
        const success = () => {
          postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF, 200);
          const snackbarText = `${count} visit${
            count > 1 ? "s" : ""
          } updated successfully`;
          postMessage(
            MSG_FETCH_VISITS,
            { message: snackbarText, date: firstVisitDate },
            500
          );
        };

        const id = reqBody._id;
        if (id) {
          Api.POST(API_UPDATE_DRAFTS_DELETE, { draft_ids: [id] }, (_r) =>
            success()
          );
        } else {
          success();
        }
      }
    });*/
  };

  _objSame(obj1: any, obj2: any, excludeKeys?: string[]) {
    const keys1 = Object.keys(obj1)
      .filter((k: string) => !excludeKeys || excludeKeys.indexOf(k) === -1)
      .sort();
    const keys2 = Object.keys(obj2)
      .filter((k: string) => !excludeKeys || excludeKeys.indexOf(k) === -1)
      .sort();
    if (keys1.length !== keys2.length) return false;
    for (let k = keys1.length; k--;) {
      const k1 = keys1[k],
        k2 = keys2[k];
      if (k1 !== k2 || JSON.stringify(obj1[k1]) !== JSON.stringify(obj2[k2])) {
        return false;
      }
    }
    return true;
  }

  // Compute detailed changes by comparing at the before & after visits
  _computeChanges(v1: Visit, v2: Visit) {
    const self = this,
      changes = self.state.changes;
    const objSame = self._objSame;
    const sortBy = (arr: any[], sortProp: string) => {
      return arr.sort((a: any, b: any) =>
        a[sortProp] > b[sortProp] ? 1 : a[sortProp] < b[sortProp] ? -1 : 0
      );
    };
    const strArrSame = (arr1?: string[], arr2?: string[]) => {
      if (arr1 === arr2) return true;
      if (!arr1 || !arr2) return false;
      return arr1.sort().join("-") === arr2.sort().join("-");
    };
    const objArrSame = (arr1: any[], arr2: any[], sortProp: string) => {
      if (arr1 === arr2) return true;
      if (!arr1 || !arr2) return false;
      const len1 = arr1.length;
      if (len1 !== arr2.length) return false;
      const a = sortBy(arr1, sortProp),
        b = sortBy(arr2, sortProp);
      for (let k = len1; k--;) {
        if (!objSame(a[k], b[k])) return false;
      }
      return true;
    };

    const pushChange = (
      title: string,
      icon: string,
      before: any,
      after: any,
      className?: string
    ) => {
      changes.push({ title, icon, before, after, className });
    };

    const loc1 = v1[visit_location_address],
      loc2 = v2[visit_location_address];
    const locTxt1 = getLocationText(loc1),
      locTxt2 = getLocationText(loc2);
    if (locTxt1 !== locTxt2) {
      pushChange(
        "Location",
        "/location.png",
        <span>{locTxt1}</span>,
        <span>{locTxt2}</span>
      );
    }

    const adl1 = v1[requested_services] || [],
      adl2 = v2[requested_services] || [];
    const mealReq1 = v1[meal_requirements] || [],
      mealReq2 = v2[meal_requirements] || [];

    const companionship1 = v1[companionship_description] || "";
    const companionship2 = v2[companionship_description] || "";
    const me1 = getMedicalEscortDetails(v1, this.getRegion());
    const me2 = getMedicalEscortDetails(v2, this.getRegion());
    const medicalEscortChanged = me1 !== me2;
    const adlChanged =
      !strArrSame(adl1, adl2) ||
      !strArrSame(mealReq1, mealReq2) ||
      companionship1 !== companionship2;

    if (medicalEscortChanged || adlChanged) {
      const me1Arr = (me1 || "").split(/\n\n|\n/);
      const me2Arr = (me2 || "").split(/\n\n|\n/);

      const getBullets = (
        adls: any[] = [],
        mealReq: any[] = [],
        medicalEscort: any[],
        companionship?: string
      ) => {
        const list = adls.map((adl: string) => (
          <React.Fragment key={adl}>
            <span key={adl} className="vur-bullet">
              {adl}
            </span>

            {adl === COMPANIONSHIP && (
              <span className="vur-sub-bullet">{companionship}</span>
            )}

            {adl === MEDICAL_ESCORT &&
              (medicalEscort || []).map((inst: string) => (
                <span key={inst} className="vur-sub-bullet">
                  {inst.slice(2)}
                </span>
              ))}

            {adl === MEAL_ARRANGEMENT &&
              (mealReq || []).map((mreq: string) => (
                <span key={mreq} className="vur-sub-bullet">
                  {mreq}
                </span>
              ))}
          </React.Fragment>
        ));

        return list;
      };
      const secTitle = adlChanged ? ADL_SERVICES : ME_INSTRUCTIONS;
      pushChange(
        secTitle,
        "/services_green.png",
        getBullets(adl1, mealReq1, me1Arr, companionship1),
        getBullets(adl2, mealReq2, me2Arr, companionship2)
      );
    }

    const procFragment = (list: Procedure[]) => {
      return list.map((p) => (
        <React.Fragment key={p.name}>
          <span className="vur-bullet">{`${p.name} x ${p.quantity}`}</span>

          {(p.consumables || [])[0] && (
            <span className="vur-sub-bullet vur-proc-bullet">
              <Txt r inline mr={6}>
                Consumables:
              </Txt>
              {p.consumables?.join(", ")}
            </span>
          )}
        </React.Fragment>
      ));
    };

    const procs1 = v1[nursing_procedure] || [];
    const procs2 = (v2[nursing_procedure] || []).map((p) => {
      p.consumables = p.consumables || [];
      return p;
    });
    if (!objArrSame(procs1, procs2, "name")) {
      pushChange(
        "Nursing Procedures",
        "/nursing_procedures.png",
        procFragment(procs1),
        procFragment(procs2)
      );
    }

    const nurseReq1 = v1[is_nurse_required]
      ? NURSE_REQUIREMENTS[2]
      : v1[is_nurse_requested]
        ? NURSE_REQUIREMENTS[1]
        : NURSE_REQUIREMENTS[0];
    const nurseReq2 = v2[is_nurse_required]
      ? NURSE_REQUIREMENTS[2]
      : v2[is_nurse_requested]
        ? NURSE_REQUIREMENTS[1]
        : NURSE_REQUIREMENTS[0];
    const reason1 = v1[reason_for_nurse] || "",
      reason2 = v2[reason_for_nurse] || "";
    if (nurseReq1 !== nurseReq2 || reason1 !== reason2) {
      pushChange(
        "Nurse Requirements",
        "/nurse.png",
        <>
          <span className="mb">{nurseReq1}</span>
          <span>{reason1}</span>
        </>,
        <>
          <span className="mb">{nurseReq2}</span>
          <span>{reason2}</span>
        </>
      );
    }

    const therapy1 = (v1[home_rehabilitation] || [])[0];
    const therapy2 = (v2[home_rehabilitation] || [])[0];
    const therapyDetails1 = v1[therapy_details] || {};
    const therapyDetails2 = v2[therapy_details] || {};

    const eo1 = therapyDetails1[expected_outcome];
    const eo2 = therapyDetails2[expected_outcome];
    const memo1 = therapyDetails1[doctor_memo];
    const memo2 = therapyDetails2[blob_urls] || therapyDetails2[doctor_memo];
    const memoNotAvail1 = therapyDetails1[doctor_memo_available] === false;
    const memoNotAvail2 = therapyDetails2[doctor_memo_available] === false;

    const memoSame =
      memo1?.toString() === memo2?.toString() &&
      memoNotAvail1 === memoNotAvail2;
    const therapyChanged = therapy1 !== therapy2 || eo1 !== eo2 || !memoSame;

    const therapyRender = (
      type?: string,
      eo?: string,
      memo?: string[],
      notAvailable?: boolean
    ) => {
      return (
        <div>
          <span>{type}</span>
          {eo && (
            <Div>
              <Txt r inline mr={6}>
                Expected Outcome:
              </Txt>
              {eo}
            </Div>
          )}
          {!memoSame && (
            <Div v>
              {(memo || notAvailable) && (
                <Txt r mb={6}>
                  Doctor's memo:
                  {notAvailable && (
                    <Txt l inline ml={6}>
                      Not Available
                    </Txt>
                  )}
                </Txt>
              )}
              <Div h w mr={-16}>
                {memo?.map((m, i) => (
                  <Img key={i} className="vur-memo" src={m} />
                ))}
              </Div>
            </Div>
          )}
        </div>
      );
    };

    if (therapyChanged) {
      pushChange(
        "Therapy",
        "/physiotherapy.png",
        therapyRender(therapy1, eo1, memo1, memoNotAvail1),
        therapyRender(therapy2, eo2, memo2, memoNotAvail2)
      );
    }

    const homeMed1 = (v1[home_medical] || [])[0];
    const homeMed2 = (v2[home_medical] || [])[0];

    if (homeMed1 !== homeMed2) {
      pushChange(
        "Home Medical Services",
        "/home_medical.png",
        <span>{homeMed1}</span>,
        <span>{homeMed2}</span>
      );
    }

    const medDetails1 = Object.assign({}, v1[home_medical_details]);
    const medDetails2 = Object.assign({}, v2[home_medical_details]);

    const medProcs1 = medDetails1.procedures || [];
    const medProcs2 = (medDetails2.procedures || []).map((p) => {
      p.consumables = p.consumables || [];
      return p;
    });
    if (!objArrSame(medProcs1, medProcs2, "name")) {
      pushChange(
        "Medical Procedures",
        "/self-serve/medical-procedure@3x.png",
        procFragment(medProcs1),
        procFragment(medProcs2)
      );
    }

    delete medDetails1.procedures;
    delete medDetails2.procedures;
    if (JSON.stringify(medDetails1) !== JSON.stringify(medDetails2)) {
      pushChange(
        "Patient Declaration",
        "/self-serve/patient-dec@3x.png",
        <PatientDeclarationDisplay visit={v1} className="vur-pd" />,
        <PatientDeclarationDisplay visit={v2} className="vur-pd" />
      );
    }

    let mob1 = v1[ambulant] || "",
      mobInst1 = v1[mobility_instruction] || "",
      mob2 = v2[ambulant] || "",
      mobInst2 = v2[mobility_instruction] || "";
    if (mob1 !== mob2 || mobInst1 !== mobInst2) {
      mob1 = MOBILITY_TYPES.find((type: string) => type.startsWith(mob1)) || "";
      mob2 = MOBILITY_TYPES.find((type: string) => type.startsWith(mob2)) || "";

      pushChange(
        "Mobility",
        "/mobility_blue.png",
        <>
          <span className="mb">{mob1}</span>
          <span>{mobInst1}</span>
        </>,
        <>
          <span className="mb">{mob2}</span>
          <span>{mobInst2}</span>
        </>
      );
    }

    const inst1 = v1[special_requests_instructions] || "",
      inst2 = v2[special_requests_instructions] || "";
    if (inst1 !== inst2) {
      pushChange(
        "Special Instructions",
        "/instructions.png",
        <span>{inst1}</span>,
        <span>{inst2}</span>
      );
    }

    const additionalRequirementsChanged = [
      has_manual_transfer,
      require_vital_sign,
      manual_transfer_help,
      manual_transfer_help_details,
      transfer_points,
      bed,
      transfer_type,
      have_hoist,
      co_accept_2_cps,
    ].find(
      (prop) =>
        ((v1 as any)[prop] || "").toString() !==
        ((v2 as any)[prop] || "").toString()
    );

    if (additionalRequirementsChanged) {
      let before: any, after: any;
      for (let i = 0; i < 2; i++) {
        const v = !i ? v1 : v2;
        const info = (
          <AdditionalRequirementsInfo
            visit={v}
            rootClassName=" "
            bulletClassName="vur-bullet"
          />
        );
        !i && (before = info);
        i && (after = info);
      }

      pushChange("Additional Requirements", "/mt-blue.png", before, after);
    }

    const notes1 = v1[internal_ops_cr_note],
      notes2 = v2[internal_ops_cr_note];
    if (notes1 !== notes2) {
      const abt = "About the CR";
      pushChange(
        "Internal Notes",
        "/private_notes.png",
        <>
          <span className="mb">{abt}</span>
          <span>{notes1}</span>
        </>,
        <>
          <span className="mb">{abt}</span>
          <span>{notes2}</span>
        </>
      );
    }

    self.setState({ changes });
  }

  _toggleExpand(expandedIds: any, visitId: string) {
    const self = this;
    if (expandedIds[visitId]) {
      delete expandedIds[visitId]; // collapse
    } else {
      expandedIds[visitId] = true; // expand
    }
    self.setState({ expandedIds: expandedIds });
  }

  _expandAll(afterVisits: any[]) {
    const ids = afterVisits.reduce((map: any, v: any) => {
      map[v._id || v.visit_id] = true;
      return map;
    }, {});
    this.setState({ expandedIds: ids });
  }

  // convert (visits/long api) breakdown to new format
  _convertBreakdown(breakdown: any) {
    const bd: any = {};
    bd.feeBreakdowns = {
      urgentFee: breakdown.urgent_fee,
      transportFee: breakdown.transport_fee,
      serviceFee: breakdown.service_fee,
      additionalServiceFee: breakdown.additional_service_fee,
    };

    const coFeeBD = breakdown.careowner_fee_breakdown || [];
    const surchargeBD = (breakdown.careowner_surcharge_fee_breakdown || []).map(
      (s: any) => {
        if (s.description.internal.indexOf("Surcharge") === -1)
          s.description.internal += " Surcharge";
        return s;
      }
    );

    bd.total = breakdown.total_fee || breakdown.total || 0; // this shouldn't happen, 0 is to prevent crash
    bd.additional_amount = breakdown.additional_amount;
    bd.gstOnVisit = breakdown.gst_on_visit;

    bd.currency = getCurrencyCode(); //breakdown.currency;
    const subtotals: any = [];

    const bds = coFeeBD.concat(surchargeBD);
    for (let k = 0; k < bds.length; k++) {
      const it: any = bds[k];

      const item: any = {};
      const type = it.type,
        intDesc = it.description.internal;
      let name = intDesc;
      if (type === "urgent_surcharge") {
        name = "Urgent Surcharge";
      } else if (type === "transport_surcharge") {
        name = "Transport Surcharge";
      }

      const subtotal = it.subtotal || it.package_subtotal;
      let symbol = getCurrencySymbol();
      let isSymbolPostfix = false;

      const chargingUnit = (it.charging_unit || "").toLowerCase();
      if (it.package_subtotal) {
        if (chargingUnit === "hour") {
          symbol = "h";
          isSymbolPostfix = true;
        } else if (chargingUnit === "procedure") {
          symbol = " " + chargingUnit;
          isSymbolPostfix = true;
        }
      }

      item.name = name;
      item.subtotal = isSymbolPostfix ? subtotal + symbol : symbol + subtotal;
      item.is_waived = it.is_waived;

      const details0 = (it.details || [])[0];
      item.breakdown = !details0
        ? []
        : [
          `${details0.unit} x ${details0.rate}/${chargingUnit} (${capitalize(
            it.rate_type || intDesc || ""
          ).replace("_", " ")})`,
        ];

      subtotals.push(item);
    }

    const breakFee = breakdown.break_fee;
    const breakFeeRate = breakdown.break_rate;

    if (breakFee && breakFeeRate) {
      const item: any = {
        name: "Break Included",
        subtotal: breakFee,
        is_negative: true,
        breakdown: [breakFee / breakFeeRate + " x " + breakFeeRate + "/hour"],
      };
      subtotals.push(item);
    }

    bd.subtotals = subtotals;
    return bd;
  }

  _visitBreakText(breakValue: any) {
    if (!breakValue || !parseFloat(breakValue)) return VISIT_BREAK_OPTIONS[0];
    return VISIT_BREAK_OPTIONS.find((v) => v.indexOf(breakValue + " ") >= 0);
  }

  // Get list of reasons for cp retention & fee waiver dropdowns
  _getReasons(cpRetention = true) {
    const props: any = this.props,
      allReasons = props.visitStore.reasons;
    if (!allReasons) return [];

    const reasons =
      allReasons[cpRetention ? "cp_retention_reasons" : "fee_waiver_reasons"] ||
      [];
    if (!reasons.length) {
      showSnackbar(
        "API Error: /visits/update/get-reasons\nPlease Contact Tech Team",
        "warning"
      );
    }

    const list: any = [],
      length = reasons.length;
    for (let k = 0; k < length; k++) {
      const r = reasons[k];
      if (r.reasons) {
        list.push({ type: "header", value: r.type });
        list.push(...r.reasons);
        k < length - 1 &&
          list.push({ type: "divider", value: "", key: `d${k}` });
      } else {
        list.push(r);
      }
    }
    return list;
  }
  // returns true if selected dropdown item needs additional textfield
  _isDetailsRequired(reasons: any[], value?: string) {
    return !!(
      value &&
      (reasons || []).find(
        (r: any) => r.value === value && r.is_details_required
      )
    );
  }

  // render cp section from the updated visit (from update review api response)
  _renderCPSection(after: any, index: number) {
    const self = this,
      props = self.props,
      reviewResponse = self.state.reviewResponse;
    let changeDetails = reviewResponse && reviewResponse[after._id];

    if (!changeDetails) return null;
    const coName = getCOName(props.recipientStore);

    const cpRetentionReasons = self._getReasons(true);
    const feeWaiverReasons = self._getReasons(false);
    const update = () => self.setState({ reviewResponse: reviewResponse });

    const toggleRetainCp = (cp: any) => {
      cp[RETAIN_CP] = !cp[RETAIN_CP];
      if (!cp[RETAIN_CP]) {
        cp[RETAIN_REASON] = cp[RETAIN_REASON_DETAILS] = UNDEF;
      } else {
        // when CP is retained hide waive fee section and clear values
        cp[WAIVE_CHANGE_FEE] = false;
        cp[WAIVE_REASON] = cp[WAIVE_REASON_DETAILS] = UNDEF;
        // can't compensate cp, when cp retained
        delete cp[COMPENSATE_CP];
      }
      update();
    };

    const toggleCompensateCp = (cp: any) => {
      cp[COMPENSATE_CP] = !cp[COMPENSATE_CP];
      update();
    };

    return changeDetails.map((cp: any, idx: number) => {
      //const id = cp._id; // smiley 1.0 cp details link not working maybe id is different
      const name = (cp.role === "Doctor" ? "Dr. " : "") + cp.name;
      const phone = cp.phone;
      const change_fees = cp.change_fees;
      const hasChangeFee = change_fees && change_fees.length > 0;
      const hasMaterialChange = cp.has_material_change;
      const canRetain = cp.can_retain;

      return (
        <div className="vur-cp-cont" key={cp._id + index + idx}>
          {hasChangeFee && (
            <div className="grow">
              <div className="h justified mb">
                <span>Change Fee</span>
                <span className="vur-change-fee">
                  {cp[RETAIN_CP] ? "0.00" : change_fees}
                </span>
              </div>
              <div className="vur-change-fee-desc">
                {cp.change_fee_description}
              </div>
            </div>
          )}

          <div className="mb vur-cp-assigned">Assigned Care Pro:</div>
          <div className="h center">
            <img
              src={cp.avatar_url || "/carepro.png"}
              alt={name}
              className="vur-cp-av"
            />

            {/* have-link={id} onClick={() => id && window.open(SMILEY_CP_DETAILS + id)} */}
            <span>{name}&nbsp;</span>
            {phone && (
              <a className="vur-phone" href={`tel:${phone}`}>
                ({phone})
              </a>
            )}
          </div>

          {!hasMaterialChange && (
            <div className="mb vur-top8 vur-green">
              This Care Pro will remain assigned to the visit.
            </div>
          )}

          {hasMaterialChange && (
            <div className="vur-top8 vur-change-fee">
              This Care Pro will be <b>unassigned</b> from the visit.
            </div>
          )}

          {canRetain && hasMaterialChange && (
            <>
              <div
                className="h vur-checkbox-cont vur-top10"
                onClick={() => toggleRetainCp(cp)}
              >
                <Checkbox
                  style={{ display: "block" }}
                  checked={!!cp[RETAIN_CP]}
                  className="ha-checkbox"
                />
                <span>Retain Care Pro assignment</span>
              </div>

              {cp[RETAIN_CP] && (
                <TextDropdown
                  showDropdownArrow
                  inputClassName="vur-td-inp vur-top10"
                  width="100%"
                  maxWidth="100%"
                  popupWidth="100%"
                  popupMaxHeight="280px"
                  items={cpRetentionReasons}
                  titleProperty="value"
                  placeholder="Reason for retaining CP"
                  selectedItem={cp[RETAIN_REASON]}
                  onChange={(_: any, r: any) => {
                    cp[RETAIN_REASON] = r && r.value;
                    update();
                  }}
                />
              )}

              {cp[RETAIN_CP] &&
                self._isDetailsRequired(
                  cpRetentionReasons,
                  cp[RETAIN_REASON]
                ) && (
                  <InputField
                    type="text"
                    className="vur-more-details"
                    inpClassName="vur-details-inp"
                    width="100%"
                    multiLine
                    noAutoSelect
                    maxLines={3}
                    lineHeight={19}
                    blurOnTabKey
                    placeholder="Please specify details"
                    onTextChange={(_: any, t: string) => {
                      cp[RETAIN_REASON_DETAILS] = t;
                      update();
                    }}
                    text={cp[RETAIN_REASON_DETAILS]}
                  />
                )}
            </>
          )}

          {cp[CP_COMPENSATION] && !cp[RETAIN_CP] && (
            <div
              className="h vur-checkbox-cont vur-top10"
              onClick={() => toggleCompensateCp(cp)}
            >
              <Checkbox
                style={{ display: "block" }}
                checked={!!cp[COMPENSATE_CP]}
                className="ha-checkbox"
              />
              <span>
                Give 1-hour compensation to the Care Pro -{" "}
                <b>{cp[CP_COMPENSATION]}</b>
              </span>
            </div>
          )}

          {hasChangeFee && !cp[RETAIN_CP] && (
            <div className="vur-top18">
              <div className="light">
                Waive fees charged to {coName || "CO"}?
              </div>
              <div className="h vur-top10">
                <button
                  className="green-border-icon-btn vur-btn"
                  data-selected={!cp[WAIVE_CHANGE_FEE] ? "" : UNDEF}
                  onClick={(e: any) => {
                    cblur(e);
                    cp[WAIVE_CHANGE_FEE] = false;
                    cp[WAIVE_REASON] = cp[WAIVE_REASON_DETAILS] = UNDEF;
                    update();
                  }}
                >
                  <span>No</span>
                </button>
                <button
                  className="green-border-icon-btn vur-btn"
                  style={{ marginLeft: "10px" }}
                  data-selected={cp[WAIVE_CHANGE_FEE] ? "" : UNDEF}
                  onClick={(e: any) => {
                    cblur(e);
                    cp[WAIVE_CHANGE_FEE] = true;
                    update();
                  }}
                >
                  <span>Yes</span>
                </button>
              </div>

              {cp[WAIVE_CHANGE_FEE] && (
                <TextDropdown
                  showDropdownArrow
                  inputClassName="vur-td-inp vur-top10"
                  width="100%"
                  maxWidth="100%"
                  popupWidth="100%"
                  popupMaxHeight="280px"
                  items={feeWaiverReasons}
                  titleProperty="value"
                  placeholder="Select reason for waiver"
                  selectedItem={cp[WAIVE_REASON]}
                  onChange={(_: any, r: any) => {
                    cp[WAIVE_REASON] = r && r.value;
                    update();
                  }}
                />
              )}

              {self._isDetailsRequired(feeWaiverReasons, cp[WAIVE_REASON]) && (
                <InputField
                  type="text"
                  className="vur-more-details"
                  inpClassName="vur-details-inp"
                  width="100%"
                  multiLine
                  noAutoSelect
                  maxLines={3}
                  lineHeight={19}
                  blurOnTabKey
                  placeholder="Please specify details"
                  onTextChange={(_: any, t: string) => {
                    cp[WAIVE_REASON_DETAILS] = t;
                    update();
                  }}
                  text={cp[WAIVE_REASON_DETAILS]}
                />
              )}
            </div>
          )}
        </div>
      );
    });
  }

  _getVisitCardMaxHeight(visit: any) {
    let height = 2000;
    try {
      const reviewResponse = this.state.reviewResponse;
      const carepros = (reviewResponse && reviewResponse[visit._id]) || [];
      height += carepros.length * 340;
    } catch (e) {
      console.log(e);
    }
    return height;
  }

  _getTotalAmount(gstOnVisit: any, totalAmount: any) {
    const isTotalAmountCash = parseFeeValue(totalAmount).type === TYPE_CASH;

    gstOnVisit = isAU && gstOnVisit
      ? toNum(stripCurrency(gstOnVisit))
      : null;

    totalAmount = gstOnVisit && isTotalAmountCash
      ? toNum(stripCurrency(totalAmount)) + gstOnVisit
      : totalAmount;

    if (gstOnVisit && typeof totalAmount === "number") {
      return `AUD ${totalAmount.toFixed(2)}`;
    } else return totalAmount;
  };

  _renderAdditionalAmount(gstOnVisit: any, additionalAmount: any, totalAmount: any) {
    const isTotalAmountCash = parseFeeValue(totalAmount).type === TYPE_CASH;

    gstOnVisit = isAU && gstOnVisit
      ? toNum(stripCurrency(gstOnVisit))
      : null;

    additionalAmount = additionalAmount && gstOnVisit
      ? toNum(stripCurrency(additionalAmount)) + gstOnVisit
      : !additionalAmount && !isTotalAmountCash && gstOnVisit
        ? gstOnVisit
        : additionalAmount;

    if (additionalAmount) {
      return (
        <Txt color={c7C7C7C} fs={12} mt={2} textAlign="right">
          {typeof additionalAmount === "number" ? (
            `+ AUD ${additionalAmount.toFixed(2)}`
          ) : additionalAmount}
        </Txt>
      )
    };
  };

  // Render before/after pricing with expand/collapse
  _renderPricing(before: any, after: any, index: number, isAfter = false) {
    if (!before || !after) return null;

    const visit = isAfter ? after : before;
    const self = this,
      state = self.state,
      expandedIds = state.expandedIds;
    const visitId = visit._id;
    const schedule = visit[visit_schedule];
    let keyNum = 0;
    const key = () => `${index}${isAfter}${keyNum++}`;

    const startDate = parseDate(schedule.date_from);
    const endDate = parseDate(schedule.date_to);
    //const duration = dateDiffHours(startDate, endDate);

    let visitFeeBreakdown = !isAfter
      ? self._convertBreakdown(visit[payment_breakdown])
      : state.breakdownResponse.visit_breakdown[index];

    const subtotal = visitFeeBreakdown.total;
    const subtotalAdditional = visitFeeBreakdown.additional_amount;

    const breakdownItems: any[] = [];

    // Before breakdown
    if (!isAfter) {
      visitFeeBreakdown.subtotals.forEach(
        (breakdownItem: any, index: number) => {
          breakdownItems.push(
            <PricingEngineVisitBreakdownItem
              key={key()}
              _id={visitId}
              type={index.toString()}
              name={breakdownItem.name}
              price={stripCurrency(breakdownItem.subtotal)}
              descriptions={breakdownItem.breakdown}
              isNegative={breakdownItem.is_negative}
            />
          );
          breakdownItem.is_waived &&
            breakdownItems.push(
              <PricingEngineVisitBreakdownItem
                key={key()}
                _id={visitId}
                type={index.toString()}
                name={breakdownItem.name}
                price={breakdownItem.subtotal}
                descriptions={breakdownItem.breakdown}
                waived={true}
              />
            );
        }
      );
    }
    // After breakdown
    else {
      visitFeeBreakdown.details.forEach(
        (bd: BreakdownDetail, index: number) => {
          breakdownItems.push(
            <PricingEngineVisitBreakdownItem
              key={key()}
              _id={visitId}
              type={index.toString()}
              name={bd.title}
              price={bd.total || bd.price}
              descriptions={bd.description || bd.details}
              waived={!!bd.less}
            />
          );
        }
      );
    }

    const shouldShowCPs = before[required_cp] > 1 || after[required_cp] > 1;
    const isGSTIncluded = visitFeeBreakdown.gstOnVisit || visitFeeBreakdown.gst_on_visit;

    shouldShowCPs &&
      breakdownItems.push(
        <div className="h vur-pb-cont justified" key={key()}>
          <p className="pes-visit-schedule-duration">
            Number of CPs
          </p>
          <p className="pes-visit-price-breakdown">
            {visit[required_cp] || 1}
          </p>
        </div>
      );

    isAU && isGSTIncluded &&
      breakdownItems.push(
        <div className="h vur-pb-cont justified" key={key()}>
          <p className="pes-visit-schedule-duration">
            GST on Visit*
          </p>
          <p className="pes-visit-price-breakdown">
            {!isAfter
              ? visitFeeBreakdown.gstOnVisit
              : stripCurrency(visitFeeBreakdown.gst_on_visit)
            }
          </p>
        </div>
      );

    const breakChanged = before[breaks] !== after[breaks];
    const notesChanged =
      before[internal_ops_fulfillment_note] !==
      after[internal_ops_fulfillment_note];

    (notesChanged || breakChanged) &&
      breakdownItems.push(<div key={key()} className="horizontal-separator" />);

    breakChanged &&
      breakdownItems.push(
        <div className="h vur-pb-cont" key={key()}>
          <p className="pes-visit-schedule-duration">
            Visit Break: {self._visitBreakText(visit[breaks])}
          </p>
        </div>
      );

    notesChanged &&
      breakdownItems.push(
        <div className="v vur-pb-cont" key={key()}>
          <div className="mb">Fulfillment notes:</div>
          <div className="light">{visit[internal_ops_fulfillment_note]}</div>
        </div>
      );

    const collapsed = !expandedIds[visitId];
    const pricingRender = (
      <div
        className="v vur-price-cont"
        key={key()}
        is-collapsed={collapsed ? "" : UNDEF}
      >
        <div className="h">
          <div className="vur-index">{index + 1}</div>
          <div className="v grow">
            <div className="h justified">
              <div className="vur-bold">
                {formatDate(convertToDestTZ(startDate), this.getRegion())}
              </div>
              <ExpandLess
                className="vur-exp-col"
                onClick={() => self._toggleExpand(expandedIds, visitId)}
              />
            </div>
            <div className="h justified center">
              <div className="vur-p-txt">{`${dateToAMPM(
                convertToDestTZ(startDate, this.getRegion())
              )} - ${dateToAMPM(
                convertToDestTZ(endDate, this.getRegion())
              )} ${getDuration(startDate, endDate)}`}</div>
              <Div v>
                <Txt className="vur-bold" textAlign="right">
                  {this._getTotalAmount(isGSTIncluded, subtotal)}
                </Txt>
                {this._renderAdditionalAmount(isGSTIncluded, subtotalAdditional, subtotal)}
              </Div>
            </div>
          </div>
        </div>

        <div
          className="v vur-render-cont"
          style={{ maxHeight: self._getVisitCardMaxHeight(visit) }}
        >
          {breakdownItems}
          {isAfter && self._renderCPSection(visit, index)}
        </div>
      </div>
    );

    /*if (self.firstLoad) {
      self.totalPrice = (_.reduce(subtotals, (acc, item) => {
        acc = acc.add(item);
        return acc;
      }, Money.fromDecimal("0.00", appCurrency))).toString();
      self.firstLoad = false;
    }*/

    return pricingRender;
  }

  _payOnCall = (params: PayOnCall) => {
    const reqBody = this.state.breakdownRequest;
    reqBody.pay_on_call = params;
    if (incidentCenter) reqBody["from_incident_center"] = true;
    this._callConfirmApi(reqBody);
  };

  _callConfirmApi(reqBody: any) {
    //const self = this;

    const visits = reqBody.visits_info.visits;
    const count = visits.length;
    const firstVisitDate = parseDate(visits[0].visit_schedule.date_from);
    if (incidentCenter) reqBody["from_incident_center"] = true;

    Api.POST(
      API_VAL_CONFIRM_BOOKING,
      reqBody,
      (resp: any, err: any) => {
        if (!err) {
          const data = resp?.data;
          // handle error here from success response if there is one
          if (data?.error && data?.error?.error_reason === "visit_change_locked") {
            this.setState({
              coUpdateError: {
                msg_type: "Action cannot be completed.",
                err_msg:
                  "Visit has been updated by CO via app. Please try again.",
              },
            });
          };

          if (data && data.success) {
            postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF, 200);
            const snackbarText = `${count} visit${count > 1 ? "s" : ""
              } updated successfully`;
            postMessage(
              MSG_FETCH_VISITS,
              { message: snackbarText, date: firstVisitDate },
              500
            );
          }
        };
      },
      true
    );
  }

  _payRemWithCard = () => {
    const reqBody = this.state.breakdownRequest;
    this._callConfirmApi(reqBody);
  };

  _payThemselves = (mode: PayThemselvesMode) => {

    const self = this;
    const reqBody = self.state.breakdownRequest || {};
    if (incidentCenter) reqBody["from_incident_center"] = true;

    reqBody.pay_themselves = {
      payment_mode: mode,
    };

    Api.POST(
      API_VAL_CONFIRM_BOOKING,
      reqBody,
      (resp) => {
        const data = resp?.data;

        if (data && data.success) {
          self.setState({
            payThemselvesSuccess: true,
            confirmPopupOpen: false,
          });
        }
      },
      true
    );
  };

  // An email has been sent to CO to complete the payment
  _onPayThemselvesClose = () => {
    postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF);
    postMessage(MSG_REFRESH_CR_INFO, UNDEF, 100);
  };

  _closePEConfirmPopup = () => {
    this.setState({
      confirmPopupOpen: false,
    });
  };

  //rows in Totals section at the bottom
  // service fees, surcharges, change fees etc..
  renderRow(
    label: string,
    val?: number,
    formattedValue?: string,
    className?: string
  ) {
    return !val && !formattedValue ? null : (
      <div className={"h justified " + (className || "")}>
        <span>
          {!!val && val < 0 && <b>Less&nbsp;</b>}
          {label}
        </span>
        <span>
          {`${!!val && val < 0 ? "(" : ""}${val ? Math.abs(val).toFixed(2) : formattedValue
            }${!!val && val < 0 ? ")" : ""}`}
        </span>
      </div>
    );
  }

  _renderBeforeTotal(beforeVisitsMap: any, afterVisits: any[]) {
    if (!beforeVisitsMap || !afterVisits) return null;

    const self = this;
    let total = 0;
    let serviceFee = 0;
    let transportFee = 0;
    let transportFeeWaiver = 0;
    let urgentFee = 0;
    let urgentFeeWaiver = 0;
    let changeFee = 0;
    let changeFeeWaiver = 0;
    let breakFee = 0;

    let totalInHrs = 0;
    let totalInProcedures = 0;
    let additionalTotal = 0;

    let serviceFeeInHrs = 0;
    let serviceFeeInProcedures = 0;
    let additionalServiceFee = 0;
    let gstOnVisit = 0;
    let gstOnVisitStr;

    for (let k = afterVisits.length; k--;) {
      const after = afterVisits[k],
        visitId = after._id;
      const before = beforeVisitsMap[visitId];
      if (!after || !before) return null;

      const visit = before;
      const cpCount = visit["required_cp"] || 1;

      const breakdown = self._convertBreakdown(before[payment_breakdown]);

      const feeBreakdown = breakdown.feeBreakdowns;
      const subtotals = breakdown.subtotals;

      const innerTotal = parseFeeValue(breakdown.total);
      additionalTotal += toNum(stripCurrency(breakdown.additional_amount));
      totalInHrs += innerTotal.type === TYPE_HOURS ? innerTotal.value : 0;
      totalInProcedures += innerTotal.type === TYPE_PROC ? innerTotal.value : 0;
      total += innerTotal.type === TYPE_CASH ? innerTotal.value : 0;

      const innerServiceFee = parseFeeValue(feeBreakdown.serviceFee);
      additionalServiceFee += toNum(
        stripCurrency(feeBreakdown.additionalServiceFee)
      );

      gstOnVisit += toNum(breakdown.gstOnVisit);
      gstOnVisitStr = breakdown.gstOnVisit;

      serviceFeeInHrs +=
        innerServiceFee.type === TYPE_HOURS ? innerServiceFee.value : 0;
      serviceFeeInProcedures +=
        innerServiceFee.type === TYPE_PROC ? innerServiceFee.value : 0;
      serviceFee +=
        innerServiceFee.type === TYPE_CASH ? innerServiceFee.value : 0;

      for (let x = subtotals.length; x--;) {
        const subtotal = subtotals[x],
          name = subtotal.name,
          value = toNum(stripCurrency(subtotal.subtotal)) * cpCount,
          isWaived = subtotal.is_waived;

        if (name === "Transport Surcharge") {
          transportFee += value;
          isWaived && (transportFeeWaiver += value);
        } else if (name === "Urgent Surcharge") {
          urgentFee += value;
          isWaived && (urgentFeeWaiver += value);
        } else if (name === "Break Included") {
          breakFee += value;
        }
      }
    } // end visit loop

    const grandTotal = total + additionalTotal + changeFee - changeFeeWaiver + gstOnVisit;
    let totalStr = combineTotals(totalInHrs, grandTotal, totalInProcedures);
    let serviceFeeStr = combineTotals(
      serviceFeeInHrs,
      serviceFee + additionalServiceFee,
      serviceFeeInProcedures
    );

    return (
      <>
        {self.renderRow("Service Fees", UNDEF, serviceFeeStr)}
        {self.renderRow("Transport Surcharge", transportFee)}
        {self.renderRow("Transport Surcharge", -transportFeeWaiver)}
        {self.renderRow("Urgent Surcharge", urgentFee)}
        {self.renderRow("Urgent Surcharge", -urgentFeeWaiver)}
        {self.renderRow("Break Included", -breakFee)}
        {self.renderRow("Change Fees", changeFee)}
        {self.renderRow("Change Fee", -changeFeeWaiver)}
        {self.renderRow("GST on Visit*", gstOnVisit)}
        {gstOnVisit === 0 &&
          self.renderRow("GST on Visit*", UNDEF, gstOnVisitStr)
        }
        {self.renderRow(
          "Total",
          UNDEF,
          totalStr,
          "b vur-top20 vur-grand-total"
        )}
      </>
    );
  }

  _renderAfterTotal(beforeVisitsMap: any, afterVisits: any[]) {
    const self = this;
    const breakdowns = self.state.breakdownResponse?.visit_breakdown;
    const rvisits = self.state.breakdownResponse?.visits_update_info;

    if (!beforeVisitsMap || !afterVisits || !breakdowns) return null;

    let total = 0;
    let serviceFee = 0;
    let transportFee = 0;
    let transportFeeWaiver = 0;
    let urgentFee = 0;
    let urgentFeeWaiver = 0;
    let changeFee = 0;
    let changeFeeWaiver = 0;
    let breakFee = 0;

    let totalInHrs = 0;
    let totalInProcedures = 0;
    let additionalTotal = 0;

    let serviceFeeInHrs = 0;
    let serviceFeeInProcedures = 0;
    let additionalServiceFee = 0;
    let gstOnVisit = 0;
    let gstOnVisitStr;

    const TYPE_HOURS = "hours";
    const TYPE_CASH = "cash";
    const TYPE_PROC = "procedures";
    const CAREPROS = "carepros";

    for (let k = breakdowns.length; k--;) {
      const vbd = breakdowns[k];
      const details = vbd.details || [];

      const after = afterVisits[k];
      const cpCount = after["required_cp"] || 1;

      const innerTotal = parseFeeValue(vbd.total);
      additionalTotal += toNum(stripCurrency(vbd.additional_amount));

      const innerServiceFee = parseFeeValue(vbd.service_fee);
      additionalServiceFee += toNum(stripCurrency(vbd.additional_service_fee));

      gstOnVisit += toNum(stripCurrency(vbd.gst_on_visit));
      gstOnVisitStr = stripCurrency(vbd.gst_on_visit);

      totalInHrs += innerTotal.type === TYPE_HOURS ? innerTotal.value : 0;
      totalInProcedures += innerTotal.type === TYPE_PROC ? innerTotal.value : 0;
      total += innerTotal.type === TYPE_CASH ? innerTotal.value : 0;

      serviceFeeInHrs +=
        innerServiceFee.type === TYPE_HOURS ? innerServiceFee.value : 0;
      serviceFeeInProcedures +=
        innerServiceFee.type === TYPE_PROC ? innerServiceFee.value : 0;
      serviceFee +=
        innerServiceFee.type === TYPE_CASH ? innerServiceFee.value : 0;

      const transportSurcharge = "transport surcharge";
      const urgentSurcharge = "urgent surcharge";

      const isSurchargeItem = (item: any, type: string) => {
        return !!details.find(
          (d: any) =>
            d.title === item.title &&
            (d.title.toLowerCase().indexOf(type) >= 0 ||
              ((d.details || [])[0] || "").toLowerCase().indexOf(type) >= 0)
        );
      };

      for (let x = details.length; x--;) {
        const bd = details[x];
        const title = bd.title.toLowerCase();
        const isWaived = bd.less;
        const value = toNum(stripCurrency(bd.total)) * cpCount;

        if (isSurchargeItem(bd, transportSurcharge)) {
          !isWaived && (transportFee += value);
          isWaived && (transportFeeWaiver += value);
        } else if (isSurchargeItem(bd, urgentSurcharge)) {
          urgentFee += value;
          isWaived && (urgentFeeWaiver += value);
        } else if (title.indexOf("Break Included") >= 0) {
          breakFee += value;
        }
      }

      // calculate change fees
      const cps = rvisits[k][CAREPROS];
      for (let j = isBlank(cps) ? 0 : cps.length; j--;) {
        const cp = cps[j];
        const change_fees = cp.change_fees;
        if (change_fees && !cp[RETAIN_CP]) {
          const feeNum = toNum(stripCurrency(change_fees));
          changeFee += feeNum;
          if (cp[WAIVE_CHANGE_FEE]) {
            changeFeeWaiver += feeNum;
          }
        }

        const changeFeeGST = cp.change_fee_gst;
        if (changeFeeGST && !cp[RETAIN_CP]) {
          gstOnVisit += toNum(changeFeeGST);
          if (cp[WAIVE_CHANGE_FEE]) {
            gstOnVisit -= toNum(changeFeeGST);
          }
        }
      }
    } // end visit loop

    const grandTotal = total + additionalTotal + changeFee - changeFeeWaiver + gstOnVisit;
    let totalStr = combineTotals(totalInHrs, grandTotal, totalInProcedures);
    let serviceFeeStr = combineTotals(
      serviceFeeInHrs,
      serviceFee + additionalServiceFee,
      serviceFeeInProcedures
    );

    return (
      <>
        {self.renderRow("Service Fees", UNDEF, serviceFeeStr)}
        {self.renderRow("Transport Surcharge", transportFee)}
        {self.renderRow("Transport Surcharge", -transportFeeWaiver)}
        {self.renderRow("Urgent Surcharge", urgentFee)}
        {self.renderRow("Urgent Surcharge", -urgentFeeWaiver)}
        {self.renderRow("Break Included", -breakFee)}
        {self.renderRow("Change Fees", changeFee)}
        {self.renderRow("Change Fee", -changeFeeWaiver)}
        {self.renderRow("GST on Visit*", gstOnVisit)}
        {gstOnVisit === 0 &&
          self.renderRow("GST on Visit*", UNDEF, gstOnVisitStr)
        }
        {self.renderRow(
          "Total",
          UNDEF,
          totalStr,
          "b vur-top20 vur-grand-total"
        )}
        {gstOnVisit || gstOnVisitStr ? (
          <span className="vur-gst-disclaimer">
            *Final amount will be confirmed upon visit completion.
          </span>
        ) : (
          ''
        )
        }
      </>
    );
  }

  render() {
    const self = this,
      state = self.state,
      props = self.props;
    const updateData = props.reviewUpdateData;
    if (!updateData) return <div />;

    const changes = state.changes,
      haveServiceChange = !!(changes && changes[0]),
      beforeVisitsMap = state.originalVisits || {},
      afterVisits = state.afterVisits || [];

    //For wallet dropdown
    const recipientStore = props.recipientStore;
    const details = recipientStore && recipientStore.careRecipient;
    const cr = details && details.cr;
    const co = details && details.co;
    const cos = cr && cr.care_owners;
    const isConcierge = !!co?.wallet?.is_concierge;
    const coId = cos && cos[0].user_id;
    const haveCard = !!(co && co.wallet && co.wallet.card);

    const breakdownReq = state.breakdownRequest;
    const updateInfo = breakdownReq?.visits_update_info || {};
    const visits = breakdownReq?.visits_info?.visits || [];

    return (
      <div className="vur v">
        <div className="h vc vur-top-cont">
          <div className="vur-h1 g">Review &amp; Confirm</div>
          {co && (
            <WalletDropdown
              coId={coId}
              haveCard={haveCard}
              wallet={co.wallet}
              onCardAdded={() => self.post(MSG_REFRESH_CR_DETAILS)}
            />
          )}
        </div>
        <div className="vur-hline" />

        <div className="vur-sections h">
          <div className="vur-sec1">
            <div className="vur-h2">Reason for change</div>
            <div className="vur-h3">Client requested for change at:</div>
            <div className="vur-txt">{self._dateText(updateInfo)}</div>

            <div className="vur-h3 vur-top20">Initiator</div>
            <div className="vur-txt">{self._initiator(updateInfo)}</div>

            <div className="vur-h3 vur-top20">Reason</div>
            <div className="vur-txt">{updateInfo[REASON_FOR_CHANGE]}</div>
            <div className="vur-txt">
              {updateInfo[REASON_FOR_CHANGE_DETAILS]}
            </div>

            <div className="vur-h2 vur-top30">
              Changes on Service Requirements
            </div>

            {haveServiceChange && (
              <>
                <ol className="vur-change-bullets">
                  {changes.map((c: any) => (
                    <li key={c.title}>{c.title}</li>
                  ))}
                </ol>
                <Button
                  size="small"
                  className="ha-dialog-done vur-detailed-changes"
                  onClick={() => self.setState({ changeDetailOpen: true })}
                >
                  View detailed changes
                </Button>
              </>
            )}
            {!haveServiceChange && <div className="vur-gray">No changes</div>}
          </div>
          <div
            className="vur-sec2"
            data-hid={self._summarySecHidden() ? "" : UNDEF}
          >
            <div className="h vur-sec2-top">
              <img src="/pricing.png" alt="" width="19" height="19" />
              <img alt="" width="10" height="0" />
              <div className="vur-h2 grow">Booking Summary</div>
              <Button
                className="vur-outline-button"
                onClick={() => self.setState({ expandedIds: {} })}
              >
                Collapse All
              </Button>
              <b
                className="vertical-separator"
                style={{ height: 16, margin: "0 4px" }}
              />
              <Button
                className="vur-outline-button"
                onClick={() => self._expandAll(afterVisits)}
              >
                Expand All
              </Button>
            </div>
            <div className="vur-sec2-row vur-bef-aft">
              <span className="vur-h3">Before</span>
              <span className="vur-h3">After</span>
            </div>

            {/* Render before vs after pricing table */}
            {afterVisits.map((v: any, index: number) => {
              const after = v,
                before = beforeVisitsMap[v._id];
              return (
                <div className="vur-sec2-row" key={v._id}>
                  <div className="v">
                    {self._renderPricing(before, after, index)}
                  </div>

                  <div className="v">
                    {self._renderPricing(before, after, index, true)}
                  </div>
                </div>
              );
            })}

            <div className="vur-sec2-row">
              <div className="vur-total-box">
                {self._renderBeforeTotal(beforeVisitsMap, afterVisits)}
              </div>

              <div className="vur-total-box">
                {self._renderAfterTotal(beforeVisitsMap, afterVisits)}
              </div>
            </div>

            {/* Confirm Visits update button */}
            <div className="vur-confirm-box vur-top20">
              {/* {state.reqBody._id && (
                <Button
                  className="vur-btn-discard"
                  onClick={self._discardChanges}
                >
                  Discard Changes
                </Button>
              )}

              <Button className="vur-btn-save" onClick={self._saveChanges}>
                Save Changes
              </Button> */}

              <Button
                variant="contained"
                color="primary"
                className="ha-btn-green vur-btn-update"
                disabled={!self._isConfirmEnabled()}
                onClick={self._confirmUpdate}
              >
                Confirm Visit{visits[1] ? "s" : ""} Update
              </Button>
            </div>
          </div>
        </div>

        {/* Detailed changes dialog */}
        {state.changeDetailOpen && (
          <PortalDialog
            className="ha-dialog vur-dialog ha-dialog-appear"
            result={() => self.setState({ changeDetailOpen: false })}
          >
            <IconButton
              className="vur-dialog-close"
              onClick={() => self.setState({ changeDetailOpen: false })}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <div className="vur-dlg-heading vur-dlg-top">
              Changes on Service Requirements
            </div>

            <div className="vur-dlg-content sbar">
              <div className="h vur-row">
                <div className="vur-dlg-heading vur-dlg-diff vur-sec-before">
                  Original
                </div>
                <div className="vur-dlg-heading vur-dlg-diff">Updated</div>
              </div>

              {changes.map((c: any) => {
                return (
                  <div key={c.title} className="h vur-row">
                    <div className="v vur-sec vur-sec-before">
                      <img className="vur-ico" alt="" src={c.icon} />
                      <span className="vur-h3">
                        {c.title === ME_INSTRUCTIONS ? ADL_SERVICES : c.title}
                      </span>
                      {c.before}
                      <div className="vur-hline" />
                    </div>

                    <div className="v vur-sec">
                      <img className="vur-ico" alt="" src={c.icon} />
                      <span className="vur-h3">
                        {c.title === ME_INSTRUCTIONS ? ADL_SERVICES : c.title}
                      </span>
                      {c.after}
                      <div className="vur-hline" />
                    </div>
                  </div>
                );
              })}
            </div>
          </PortalDialog>
        )}

        {state.confirmPopupOpen && state.breakdownResponse && (
          <Elements stripe={stripePromise}>
            <PEConfirmPopup
              breakdown={state.breakdownResponse}
              isUpdate
              isConcierge={isConcierge}
              selectedPackage={state.selectedPackage}
              onPayOnCallConfirm={self._payOnCall}
              onClose={self._closePEConfirmPopup}
              onPayThemselves={self._payThemselves}
              firstVisitStartTime={self.firstVisitStartTime}
              onPayRemainingWithCardContinue={self._payRemWithCard}
            />
          </Elements>
        )}
        {state.coUpdateError && (
          <CoUpdateErrorPopup
            msg_type={state.coUpdateError.msg_type}
            err_msg={state.coUpdateError.err_msg}
            onClose={() => {
              postMessage(MSG_SHOW_CALENDAR_VIEW, UNDEF, 200);
            }}
          />
        )}
        {state.payThemselvesSuccess && (
          <PayThemselvesSuccessPopup onClose={self._onPayThemselvesClose} />
        )}
      </div>
    );
  }
}

export const TYPE_HOURS = "hours";
export const TYPE_CASH = "cash";
export const TYPE_PROC = "procedures";

// Convert any value to number, return 0 for errors
export const toNum = (v: any) => {
  try {
    return parseFloat(v) || 0;
  } catch (e) {
    return 0;
  }
};

export type FeeType = { value: number; type: string };

// value can be "SGD 10.00", "3h", "3 hours", "3 procedures"
// return {value: 10, type: "cash"}, {value: 3, type: "hour"} etc..
export const parseFeeValue = (value: string): FeeType => {
  const stripped = stripCurrency(value).toLowerCase();
  const numValue = toNum(stripped);

  if (stripped.indexOf("h") > 0) {
    return { value: numValue, type: TYPE_HOURS };
  }

  if (stripped.indexOf("p") > 0) {
    return { value: numValue, type: TYPE_PROC };
  }

  return { value: numValue, type: TYPE_CASH };
};

/**
 * return examples
 * 3 hours
 * 3 hours + SGD 10.00
 * 3 procedures + SGD 10.00
 * 3 hours + 1 procedure + SGD 10.00
 */
export function combineTotals(
  hours: number,
  amount: number,
  procedures: number
) {
  const hrStr = hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : "";
  const procedureStr =
    procedures > 0 ? `${procedures} procedure${procedures > 1 ? "s" : ""}` : "";
  const feeStr = amount > 0 ? `${getCurrencyCode()} ${amount.toFixed(2)}` : "";
  return [hrStr, procedureStr, feeStr].filter((f) => f).join(" + ");
}

export function parseFees(fees: FeeType[]) {
  if (!fees || !fees[0]) return "";
  let hours = 0,
    procedures = 0,
    cash = 0;
  for (let k = fees.length; k--;) {
    const type = fees[k].type;
    const value = fees[k].value;
    if (type === TYPE_HOURS) hours += value;
    if (type === TYPE_PROC) procedures += value;
    if (type === TYPE_CASH) cash += value;
  }
  return combineTotals(hours, cash, procedures);
}

const mapStateToProps = (state: any) => {
  return { ...state };
};

const mapDispatchToProps = (dispatch: any) => ({
  getReasons: () => dispatch(getReasons()),
  resetPricing: () => dispatch(resetPricing()),
});

export default withRouter(
  connect<VisitUpdateReviewState, VisitUpdateReviewConnectProps>(
    mapStateToProps,
    mapDispatchToProps
  )(VisitUpdateReview)
);
